import { http } from '@/http/axios.js';
import { http_limit } from '@/http/axios_limit.js'
import axios from 'axios';
import { getToken } from '@/utils/auth';
import { dateFormat } from '@/utils/index.js';
import { showScreenLoading, hideScreenLoading } from '@/http/loading.js';
import { Message } from 'element-ui';

// 统计
export function getOrderStaticAPI() {
    return http({
        url: '/admin/order/status/stat',
        method: 'get',
    });
}
// 统计
export function getMallOrderStaticAPI() {
    return http({
        url: '/admin/order/mall/status/stat',
        method: 'get',
    });
}
// 列表
export function getListAPI(params) {
    return http({
        url: '/admin/order/page',
        method: 'get',
        params,
    });
}
// 列表
export function getMallListAPI(params) {
    return http({
        url: '/admin/order/mall/page',
        method: 'get',
        params,
    });
}
// 详情
export function getDetailAPI(orderNo) {
    return http({
        url: '/admin/order/detail',
        method: 'get',
        params: { orderNo },
    });
}

// 发货
export function handleDeliveryAPI(data) {
    return http({
        url: '/admin/order/delivery',
        method: 'post',
        data,
    });
}
// 发货-门店
export function handleDeliveryStoreAPI(data) {
    return http({
        url: '/admin/order/pickup',
        method: 'post',
        data,
    });
}
// 订单账单列表
export function getOrderBillListAPI(orderNo) {
    return http({
        url: '/admin/order/bill/list',
        method: 'get',
        params: { orderNo },
    });
}
// 订单取消
export function handleOrderCancelAPI(data) {
    return http({
        url: '/admin/order/cancel',
        method: 'post',
        data: data,
    });
}
export function getCancelReasonAPI(params) {
    return http({
        url: "/admin/order/cancelReason/list",
        method: "get",
        params,
    });
}
// 下载合同
export function downloadOrderContractAPI(orderNo) {
    return http({
        url: '/admin/order/contract/download',
        method: 'post',
        data: { orderNo },
    });
}
// 下载合同
export function downloadOrderReceiptAPI(orderNo) {
    return http({
        url: '/admin/order/receipt/download',
        method: 'post',
        data: { orderNo },
    });
}

//门店结算金额明细
export function getSettleInfoAPI(params) {
    return http({ url: '/admin/order/settle/info', method: 'get', params });
}
// 合同详情
export function getContractDetailAPI(orderNo) {
    return http({
        url: '/admin/order/contract/detail',
        method: 'get',
        params: { orderNo },
    });
}
// 全部导出
export function exportOrderAPI(data) {
    showScreenLoading();
    axios({
        method: 'post',
        url: '/api/admin/order/export',
        responseType: 'blob',
        data,
        headers: {
            Authorization: getToken() || '',
        },
    })
        .then(async (res) => {
            hideScreenLoading();
            let data = res.data;
            let url = window.URL.createObjectURL(new Blob([data]));
            let a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            let filename = `订单列表-${dateFormat()}.xlsx`;
            a.setAttribute('download', decodeURIComponent(filename));
            document.body.appendChild(a);
            a.click(); //执行下载
            window.URL.revokeObjectURL(a.href); //释放url
            document.body.removeChild(a); //释放标签
        })
        .catch((error) => {
            hideScreenLoading();
        });
}

// 下载文件2
export function downloadPDF(pdfUrl, name) {
    showScreenLoading();
    axios({
        url: pdfUrl,
        method: 'GET',
        responseType: 'blob', // 必须指定为blob类型才能下载
    }).then(
        (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            hideScreenLoading();
        },
        (reason) => {
            hideScreenLoading();
            Message.error('下载失败！');
        }
    );
}
// 完成订单
export function handleCompleteAPI(data) {
    return http({
        url: '/admin/order/complete',
        method: 'post',
        data,
    });
}
// 提前归还
export function handleAheadReturnAPI(data) {
    return http({
        url: '/admin/order/aheadReturn',
        method: 'post',
        data,
    });
}
// 首付明细
export function getOfflinePayDetailAPI(orderNo) {
    return http({
        url: '/admin/order/prepay/detail',
        method: 'get',
        params: { orderNo },
    });
}
// 提交首付
export function submitOfflinePayAPI(orderNo) {
    return http({
        url: '/admin/order/prepay/offlinePay',
        method: 'post',
        data: { orderNo },
    });
}
// 撞库
export function hitAPI(orderNo) {
    return http({
        url: '/admin/order/roster/hit',
        method: 'post',
        data: { orderNo },
    });
}
// 查询订单售后状态
export function getAfterSaleStatusAPI(orderNo) {
    return http({
        url: '/admin/order/afterSale/status',
        method: 'get',
        params: { orderNo },
    });
}
// 更新订单售后状态
export function submitAfterSaleStatusAPI(data) {
    return http({
        url: '/admin/order/afterSale/status/edit',
        method: 'post',
        data,
    });
}
// 查询设备状态
export function getDeviceStatusAPI(orderNo) {
    return http({
        url: '/admin/order/device/status',
        method: 'get',
        params: { orderNo },
    });
}
// 更新设备状态
export function submitDeviceStatusAPI(data) {
    return http({
        url: '/admin/order/device/status/edit',
        method: 'post',
        data,
    });
}
export function getOrderReviewDetailAPI(orderNo) {
    return http({
        url: '/admin/order/review/detail',
        method: 'get',
        params: { orderNo },
    });
}

// 线下签收
export function submitConfirmReceiveAPI(data) {
    return http({
        url: '/admin/order/receive',
        method: 'post',
        data,
    });
}

export function importOrderExcelAPI(data) {
    return http_limit({
        url: '/admin/order/excel/import',
        method: 'post',
        data
    })
}
